import { ExperimentGroup } from "../config/experimentgroups";

export const getClassTooltip = (egIndex) => {
  if (egIndex === ExperimentGroup.UpwardSC2025.index || egIndex === ExperimentGroup.DownwardSC2025.index) {
    return {
      title: "Average progress of students that are similar to you",
      addOn: "Average learning of students that are similar to you",
    };
  }
  return {
    title: "Average progress of your class",
    addOn: "Average learning of your class",
  };
};
